module.exports = __webpack_public_path__ + "static/media/battery-slash.765caaf9.svg";